<template>
	<div class="content-wapper">
		<el-row class="navigation">
		    <el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/zscqzhfw/zyrzfw' }">质押融资服务</el-breadcrumb-item>
					<el-breadcrumb-item>申报</el-breadcrumb-item>
				</el-breadcrumb>
		    </el-col>
		</el-row>
		<div class="table-div">
			<div class="table-div-title">
				<el-row :gutter="10" class="mb8">
					<el-col>
						<div class="tubiao">
							<!-- <i class="el-icon-s-custom"></i> -->
							<span class="tubiao-span">申报信息</span>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="form-div">
				<el-form ref="form" :model="form" :rules="rules" label-width="250px" label-position="right">
					<el-row>
						<el-col :span="10">
							<el-form-item label="所属区县" prop="orgcode">
								<el-select v-model="form.orgcode" size="medium" clearable style="width: 16.66625rem;" disabled >
								  <el-option
								    v-for="item in orgcodeOptions"
								    :key="item.deptCode"
								    :label="item.shortName"
								    :value="item.deptCode">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="企业规模" prop="entscale">
								<el-select v-model="form.entscale" size="medium" clearable style="width: 16.66625rem;">
								  <el-option
								    v-for="item in entscaleOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="企业名称" prop="entname">
								<el-input v-model="form.entname"  disabled />
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="统一社会信用代码" prop="uniscid">
								<el-input v-model="form.uniscid" disabled />
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="贷款银行" prop="loalbank">
								<el-input v-model="form.loalbank" />
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="专利产品新增产值" prop="patentAddValue">
								<el-tooltip class="item" effect="light" content="请填报上年度数据" placement="right"><el-input id="patentAddValue" v-model="form.patentAddValue" @blur="checkZfMoney" clearable/>
								</el-tooltip></el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="贷款额" prop="loalmoney">
								<el-input v-model="form.loalmoney" @blur="valueChange" clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="新增税收" prop="addTaxRevenue">
								<el-tooltip class="item" effect="light" content="请填报上年度数据" placement="right"><el-input id="addTaxRevenue" v-model="form.addTaxRevenue" @blur="checkZfMoney" clearable/>
								</el-tooltip></el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="新增利润" prop="addProfit">
								<el-tooltip class="item" effect="light" content="请填报上年度数据" placement="right"><el-input id="addProfit" v-model="form.addProfit" @blur="checkZfMoney" clearable/>
								</el-tooltip></el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="新申请专利(项)" prop="newPatent">
								<el-tooltip class="item" effect="light" content="请填报上年度数据" placement="right"><el-input v-model="form.newPatent" />
								</el-tooltip></el-form-item>
						</el-col><el-col class="remarks" :span="1">
					</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="新增就业(人)" prop="newEmployment">
								<el-tooltip class="item" effect="light" content="请填报上年度数据" placement="right"><el-input v-model="form.newEmployment" />
								</el-tooltip></el-form-item>
						</el-col>

						<el-col :span="10">
							<el-form-item label="新授权专利(项)" prop="newAuthPatent">
								<el-tooltip class="item" effect="light" content="请填报上年度数据" placement="right"><el-input v-model="form.newAuthPatent" />
								</el-tooltip></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="借款合同编号" prop="loanContractNo">
								<el-input v-model="form.loanContractNo" />
							</el-form-item>
						</el-col><el-col class="remarks" :span="1"></el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<el-form-item label="事项类型" prop="sxlx">
								<el-select v-model="form.sxlx" size="medium" clearable style="width: 16.66625rem;">
								  <el-option
								    v-for="item in sxlxOptions"
								    :key="item.dictValue"
								    :label="item.dictLabel"
								    :value="item.dictValue">
								  </el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<hr />
					<el-row v-if="form.sxlx == '0'">
						<el-col :span="10">
							<el-form-item label="实际贷款利率" prop="actualLoanRate">
								<el-input v-model="form.actualLoanRate" placeholder="请输入不超过100的数值" type="number"
								oninput="if(value>100)value=100;if(value<0)value=0" clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">%</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="专利权占比" prop="patentRight">
								<el-input v-model="form.patentRight " placeholder="请输入不超过100的数值" type="number"
								oninput="if(value>100)value=100;if(value<0)value=0"
								 clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">%</el-col>
					</el-row>
					<el-row v-if="form.sxlx == '0'">
						<el-col :span="10">
							<el-form-item label="贷款合同签订日上月LPR" prop="loanContractLpr">
								<el-input v-model="form.loanContractLpr" type="number"
								 placeholder="请输入不超过100的数值" oninput="if(value>100)value=100;if(value<0)value=0"
								 clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">%</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="评估费" prop="assessmentFee">
								<el-input v-model="form.assessmentFee" @blur="valueChange" clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
					</el-row>
					<el-row v-if="form.sxlx == '0'">
						<el-col :span="10">
							<el-form-item label="贷款日期(起始)" prop="loanStarttime">
								<el-date-picker clearable size="small" v-model="form.loanStarttime"
									type="date" value-format="yyyy-MM-dd" style="width: 16.66625rem;"
									:picker-options="pickerOptions">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="贷款日期(截止)" prop="loanEndtime">
								<el-date-picker clearable size="small" v-model="form.loanEndtime"
									type="date" value-format="yyyy-MM-dd" style="width: 16.66625rem;"
									:picker-options="pickerOptions" @blur="CompareDate">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row v-if="form.sxlx == '0'">
						<el-col :span="10">
							<el-form-item label="贴息" prop="discount">
								<el-input @blur="valueChange"  v-model="form.discount"></el-input>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="贴息时间(天数)" prop="discountTime">
								<el-input v-model="form.discountTime" oninput="value=value.replace(/[^\d]/g,'')" clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">天</el-col>
					</el-row>
					<el-row v-if="form.sxlx == '0'">
						<el-col :span="10">
							<el-form-item label="评估费补贴" prop="assessmentFeeSubsidy">
								<el-input @blur="valueChange"   v-model="form.assessmentFeeSubsidy"></el-input>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="资助合计" prop="totalFunding">
								<el-input v-model="form.totalFunding" disabled/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
					</el-row>
					<el-row v-if="form.sxlx == '1'">
						<el-col :span="10">
							<el-form-item label="保险合同编号" prop="insuranceContractNo">
								<el-input v-model="form.insuranceContractNo" />
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="保险承保金额" prop="insuredAmount">
								<el-input v-model="form.insuredAmount" @blur="valueChange" clearable/>
							</el-form-item>
						</el-col>	
						<el-col class="remarks" :span="1">万元</el-col>
					</el-row>
					<el-row v-if="form.sxlx == '1'">
						<el-col :span="10">
							<el-form-item label="保险费率" prop="premiumRate">
								<el-input v-model="form.premiumRate" type="number"
								placeholder="请输入不超过100的数值" oninput="if(value>100)value=100;if(value<0)value=0"
								clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">%</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="应缴保费" prop="premiumPayable">
								<el-input v-model="form.premiumPayable" @blur="valueChange" clearable/>
							</el-form-item>
						</el-col>
							<el-col class="remarks" :span="1">万元</el-col>
					</el-row>
					<el-row v-if="form.sxlx == '1'">
						<el-col :span="10">
							<el-form-item label="已缴保费" prop="premiumPaid">
								<el-input v-model="form.premiumPaid" @blur="valueChange" clearable/>
							</el-form-item>
						</el-col>
						<el-col class="remarks" :span="1">万元</el-col>
						<el-col :span="10" style="margin-left: -3.25rem;">
							<el-form-item label="申请补贴" prop="applyForSubsidies">
								<el-input v-model="form.applyForSubsidies" @blur="valueChange" clearable/>
							</el-form-item>
						</el-col>	
						<el-col class="remarks" :span="1">元</el-col>
					</el-row>
					<el-row>
						<el-col :span="20">
							<el-form-item label="备注" prop="remark">
								<el-input type="textarea" v-model="form.remark" :autosize="{ minRows: 5, maxRows: 10}"/>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="20">
							<el-form-item label="附件上传" v-if="form.recid!=undefined">
							    <attachment-list module="zyrzfw_sb_market" :businessid="form.recid" @isEmitFun="isEmitFun"></attachment-list>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item>
					    <el-checkbox v-model="promise">我承诺：我所填写的发布内容及附件真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任。</el-checkbox>
					</el-form-item>
					<el-row>
					    <el-col :span="24"  class="btn">
					        <el-button type="info" @click="submitForm('N')">保 存</el-button>
					        <el-button type="primary" @click="submitForm('Y')">提交并申报</el-button>
					    </el-col>
					</el-row>
					<el-row>
						<el-col :span="24" style="margin-top: 1.875rem;margin-left:1.875rem;text-align: left;color: #959595;">
							<span >注：保存后的信息可以在企业工作室（申办事项查询）再次编辑，提交并申报后的信息不可更改，提交申报后需等待审核。</span>
						</el-col>
					</el-row>
				</el-form>
				
			</div>
		</div>
	</div>
</template>
<!-- 需要登录 -->
<script>
	import {
		getListDept
	} from "@/api/system/dept"
	import AttachmentList from "@/views/components/AttachmentList";
	import {getToken} from "@/utils/auth";
	import { addZyrzfwsb, updateZyrzfwsb, getZyrzfwsb } from "@/api/zscq/zyrzfwsb";
	import {updatePvNum} from "@/api/itempv/pv";
	import { getEntInfo} from "@/api/xwqy/rzsqsx";
	export default {
		name: "zyrzfwSb",
		components:{
		    AttachmentList
		},
		watch:{
			form:{
				handler (val, oldVal) {
					let discount = val.discount==null || val.discount=="" || val.discount==undefined ? 0 : val.discount;
					let assessmentFeeSubsidy = val.assessmentFeeSubsidy==null || val.assessmentFeeSubsidy=="" || val.assessmentFeeSubsidy==undefined ? 0 : val.assessmentFeeSubsidy;
					val.totalFunding = parseFloat(discount)+parseFloat(assessmentFeeSubsidy);
				},
				deep: true
			}
		},
		data() {
			return {
				// 表单参数
				form: {
					recid:undefined,
					sxlx:'0',
					ywFwjgRecid:undefined,
					uniscid:undefined,
					entname:undefined,
					ywSaveStatus:undefined,
					discount:undefined,
					assessmentFeeSubsidy:undefined,
					totalFunding:undefined,
					entscale:undefined,
				},
				// 表单校验
				rules: {
					orgcode:[
					    { required: true, message: '请选择区县', trigger: 'change' }
					],
					entscale:[
					    { required: true, message: '请选择企业规模', trigger: 'change' }
					],
					entname:[
					    { required: true, message: '请输入企业名称', trigger: 'blur' }
					],
					uniscid:[
					    { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
					],
					loalbank:[
					    { required: true, message: '请输入贷款银行', trigger: 'blur' }
					],
					patentAddValue:[
					    { required: true, message: '请输入专利产品新增产值', trigger: 'blur' }
					],
					loalmoney:[
					    { required: true, message: '请输入贷款额', trigger: 'blur' }
					],
					addTaxRevenue:[
					    { required: true, message: '请输入新增税收', trigger: 'blur' }
					],
					addProfit:[
					    { required: true, message: '请输入新增利润', trigger: 'blur' }
					],
					newPatent:[
					    { required: true, message: '请输入新申请专利', trigger: 'blur' }
					],
					newEmployment:[
					    { required: true, message: '请输入新增就业', trigger: 'blur' }
					],
					loanContractNo:[
					    { required: true, message: '请输入借款合同编号', trigger: 'blur' }
					],
					newAuthPatent:[
					    { required: true, message: '请输入新授权专利', trigger: 'blur' }
					],
					actualLoanRate:[
					    { required: true, message: '请输入实际贷款利率', trigger: 'blur' }
					],
					patentRight:[
					    { required: true, message: '请输入专利权占比', trigger: 'blur' }
					],
					loanContractLpr:[
					    { required: true, message: '请输入贷款合同签订日上月LPR', trigger: 'blur' }
					],
					assessmentFee:[
					    { required: true, message: '请输入评估费', trigger: 'blur' }
					],
					loanStarttime:[
					    { required: true, message: '请输入贷款日期(起始)', trigger: 'blur' }
					],
					loanEndtime:[
					    { required: true, message: '请输入贷款日期(截止)', trigger: 'blur' }
					],
					discount:[
					    { required: true, message: '请输入贴息', trigger: 'blur' }
					],
					discountTime:[
					    { required: true, message: '请输入贴息时间(天数)', trigger: 'blur' }
					],
					assessmentFeeSubsidy:[
					    { required: true, message: '请输入评估费补贴', trigger: 'blur' }
					],
					totalFunding:[
					    { required: true, message: '请输入资助合计', trigger: 'blur' }
					],
					insuranceContractNo:[
					    { required: true, message: '请输入保险合同编号', trigger: 'blur' }
					],
					insuredAmount:[
					    { required: true, message: '请输入保险承保金额', trigger: 'blur' }
					],
					premiumRate:[
					    { required: true, message: '请输入保险费率', trigger: 'blur' }
					],
					premiumPayable:[
					    { required: true, message: '请输入应缴保费', trigger: 'blur' }
					],
					premiumPaid:[
					    { required: true, message: '请输入已缴保费', trigger: 'blur' }
					],
					applyForSubsidies:[
					    { required: true, message: '请输入申请补贴', trigger: 'blur' }
					],
				},
				deptQueryParams:{
					deptLevel:'3',
					deptCode:'3710'
				},
				orgcodeOptions:[],
				entscaleOptions:[],
				sxlxOptions:[],
				promise:false,
				isUpload:false,
				loginUser:undefined,
				recid: undefined,
				pickerOptions: {
					disabledDate(v) {
					  return v.getTime() < new Date(2018,12,2).getTime() - 86400000;//  - 86400000是否包括当天
					}
				},
			}
		},
		created() {
			this.getDicts("yw_zscq_qygm").then(response => {
			    this.entscaleOptions = response.data;
			});
			this.getDicts("yw_zscq_sxlx").then(response => {
			    this.sxlxOptions = response.data;
			});
			this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
			// console.log("this.loginUser",this.loginUser);
			if(this.loginUser != null && this.loginUser != undefined){
				// console.log("this.loginUser",this.loginUser);
				this.form.entname= this.loginUser.corname;
				this.form.uniscid = this.loginUser.cornumber;
				this.form.orgcode = this.loginUser.county;
				this.form.ywFwjgRecid = this.loginUser.ywFwjgRecid;
				this.getEntInfos();
			}
			// this.form.entscale=1;
			updatePvNum("zscq_zyrzfw_sb").then(response => {
				//pv 点击知识产权质押融资-申报
			});
			this.form.sxglRecid = this.$route.query.sxglRecid;
			// debugger
			if (this.form.sxglRecid === null || this.form.sxglRecid === undefined || this.form.sxglRecid === "") {
				this.recid = this.$route.params && this.$route.params.recid;
				this.getDetail();
			}else{
				this.form.recid = this.randomString();
			}

			this.getdeptlist();
			// this.reset();
			// console.log(this.form)
		},
		methods:{
			getEntInfos(){
				//请求获取一企一档内容
				getEntInfo(this.form.ywFwjgRecid).then(response => {
					this.form.entscale = response.entscale;
					// console.log("1111111111111",this.form.entscale)
				});
			},
			CompareDate(){
				if (((new Date(this.form.loanStarttime.replace(/-/g,"\/"))) > (new Date(this.form.loanEndtime.replace(/-/g,"\/"))))){
					this.msgWarning("起始日期不能大于截止日期");
					this.form.loanEndtime = undefined;
				}
			},

			getdeptlist(){
				getListDept(this.deptQueryParams).then(res => {
					this.orgcodeOptions = res.data;
					// console.log("orgcodeOptions",this.orgcodeOptions)
				})
			},
			/** 提交按钮 */
			submitForm(status) {
				this.$refs["form"].validate(valid => {
					if(valid){
						if (this.isUpload) {
							if(this.promise){
								this.form.ywSaveStatus = status
								if ('Y' == status) {
									// this.form.status = '0';
									this.form.ywSaveStatus=status;
									this.$confirm('是否提交并申报？', '提示', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										type: 'warning'
									}).then(() => {
										//console.log(this.form);
										this.saveForm();
									})
								} else {
									this.$confirm('是否保存？', '提示', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										type: 'warning'
									}).then(() => {
										//console.log(this.form);
										this.saveForm();
									})
								}
							}else{
								this.msgWarning("请选择承诺");
							}
						} else {
							this.msgWarning("请上传附件");
						}
					}
				})
			},
			saveForm(){
				// debugger
				// console.log("sdddddddddd",this.form)
				let that = this;
				if (this.form.recid != undefined) {
					updateZyrzfwsb(this.form).then(response => {
						if (response.code === 200) {
							// debugger
							this.msgSuccess("成功");
							getEntInfo(this.form.ywFwjgRecid).then(response => {
								this.reset();
								this.$router.back();
								that.form.entscale = response.entscale;
								that.recid=undefined;
								// console.log("1111111111111",this.form.entscale)
							});
							
							// this.toPage('/main/zscqzhfw/zyrzfw');
						} else {
							this.msgWarning(response.msg);
						}
					});
				} else {
					addZyrzfwsb(this.form).then(response => {
						if (response.code === 200) {
							this.msgSuccess("成功");
							getEntInfo(this.form.ywFwjgRecid).then(response => {
								this.reset();
								this.$router.back();
								that.form.entscale = response.entscale;
								that.recid=undefined;
							});
						} else {
							this.msgWarning(response.msg);
						}
					});
				}
			},
			getDetail(){
				// console.log("this.recid",this.recid);
				if (this.recid != null && this.recid != undefined) {
					this.reset();
					const recid = this.recid;
					getZyrzfwsb(recid).then(response => {
						this.form = response.data;
					});
					this.recid=undefined;
				}
			},
			isEmitFun(str){
				if (str>0) {
					this.isUpload = true;
				}else {
					this.isUpload = false;
				}
			},
			// 表单重置
			reset() {
			    this.form = {
			        recid: undefined,
			        sxlx:'0'
			    };
				this.form.recid = this.randomString();
				this.form.sxglRecid = this.$route.query.sxglRecid;
				this.form.entname= this.loginUser.corname;
				this.form.uniscid = this.loginUser.cornumber;
				this.form.orgcode = this.loginUser.county;
				this.form.ywFwjgRecid=this.loginUser.ywFwjgRecid;
				this.promise = false;
				// this.form.entscale=undefined;
				// this.getEntInfos();
				/*this.form.assessmentFeeSubsidy = 0;
				this.form.discount = 0;
				this.form.totalFunding = 0;*/
				// console.log("this.form",this.form);
				
			},
			checkZfMoney(e){
				// console.log('11111111111111111111',e)
				/***验证正负金额**/
				let ze = /^(\-|\+)?\d+(\.\d+)?$/
				let value = e.target.value;
				if (value !== null && value !==undefined && value !==''){
					if(!ze.test(value)){
						this.msgWarning("您输入的格式不正确，请重新输入！");
						// e.target.value='';
						// 小数点后面保留2位
						e.target.focus();
						return false;
					}else{
						e.target.value = e.target.value.replace(
								/^(\-)*(\d+)\.(\d\d).*$/,
								"$1$2.$3"
						);
						return true;
					}
				}else{
					return true;
				}
			},
			valueChange(e){
				e.target.value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
				const reg = /[^\d.]/g;
				// 只能是数字和小数点，不能是其他输入
				e.target.value = e.target.value.replace(reg, "");
				// 保证第一位只能是数字，不能是点
				e.target.value = e.target.value.replace(/^\./g, "");
				// 小数只能出现1位
				e.target.value = e.target.value
				  .replace(".", "$#$")
				  .replace(/\./g, "")
				  .replace("$#$", ".");
				// 小数点后面保留2位
				e.target.value = e.target.value.replace(
				  /^(\-)*(\d+)\.(\d\d).*$/,
				  "$1$2.$3"
				);
			},
			toPage(url){
			    this.$router.push({
			        path: url,
			    });
			    this.$store.commit('SET_MAININDEX', url);
			},
		}
	}
</script>

<style scoped>
	.app-container{
	    padding:0px 15px 20px;
	}
	.navigation{
	    padding:20px 0;
	    line-height: 20px;
	    height: 60px;
	}
	.content-wapper {
		padding: 10px;
	}

	.breadcrumb-div {
		margin-top: 10px;
	}

	.table-div {
		margin-top: 1.3rem;
	}

	.table-div-title {
		width: 100%;
		height: 4.2rem;
		background-color: rgba(230, 230, 230, 0.87);
		line-height: 4.2rem;
	}

	.tubiao {
		float: left;
		font-size: 1.3rem;
		font-weight: bolder;
		margin-left: 1rem;
	}

	.tubiao-span {
		margin-left: 0.5rem;
	}

	font {
		color: #fab21b;
		font-size: 1.4rem;
		margin: 0 0.2rem;
	}
	form{
		padding: 1.25rem;
		background-color: #FFFFFF;
	}
	hr{
		width: 80%;
	}
	.remarks{
	    text-align: center;
	    color: #000000;
	    font-size: 12px;
		vertical-align:middle;
		line-height: 2.25rem;
	}
	btn{
	    text-align: center;
	}
	.btn .el-button+.el-button{
	    margin-left: 30px;
	}
	/deep/ .el-checkbox__label{
		color: #ffaa20;
	}
	/deep/.el-form-item__label{
	    padding: 0 50px 0 0;
	}
	/deep/.el-form-item__content{
	    text-align: left;
	}
	.el-input-number{
		width: 16.66625rem;
	}
	.item {
		margin: 4px;
		cursor: pointer;
	}
</style>
